var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col sm:flex-row md:flex-col md:min-h-165 relative",class:[
      _vm.width ? _vm.width : 'w-full md:w-1/4',
			_vm.padding ? _vm.padding : 'py-3 sm:py-7',
			_vm.alignTop ? 'justify-start' : 'justify-between',
			_vm.borderLight && !_vm.hideBorder ? 'border-gray-101 border-b md:border-b-0 md:border-r' : '',
			!_vm.borderLight && !_vm.hideBorder ? 'border-gray-300 border-b md:border-b-0 md:border-r' : '',
			_vm.paddingSize ? _vm.paddingSize : 'px-2 sm:px-6 lg:px-8 xl:px-12'
		]},[_c('div',{staticClass:"uppercase font-semibold leading-none text-md xl:text-base sm:w-4/12 md:w-full mb-2",class:_vm.textGray ? 'text-gray-400' : 'text-gray-200',domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('div',{staticClass:"font-semibold leading-tight sm:w-8/12 md:w-full",class:[
			_vm.valueSize ? _vm.valueSize : 'text-base leading-normal lg:text-2lg',
			_vm.textGray ? 'text-gray-500' : 'text-white',
			_vm.alignTop ? 'mt-2 sm:mt-0 md:mt-5' : ''
		],domProps:{"innerHTML":_vm._s(_vm.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }